const portal: HTMLElement = document.createElement("div");
portal.classList.add("draggable-dilaog-portal");
document.body.appendChild(portal);

export default portal;
